<div class="{{getClassForRootElement}}">
    {{#if isLegacy}}
      <span class="drag-icon-wrapper">{{icon name="drag"}}</span>
      <input id="checkbox-{{cid}}" type="checkbox" data-bind="model" name="listBuilder:isSelected">
      <label class="list-builder-item-content" for="checkbox-{{cid}}"></label>
    {{else}}
      <div class="list-builder-flex-item">
        <label class="checkbox-wrapper" for="checkbox-{{cid}}">
          <input id="checkbox-{{cid}}" type="checkbox" data-bind="model" name="listBuilder:isSelected" {{getCheckedState}}>
          <span class="checkmark">
            {{icon name="checkmark"}}
          </span>
        </label>
        <div class="list-builder-item-content"></div>
      </div>
      <div class="list-builder-flex-item">
        <span class="drag-icon-wrapper">{{icon name="drag"}}</span>
      </div>
    {{/if}}
</div>
